/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preparing_Translation_JobsInputs */

const en_preparing_translation_jobs = /** @type {(inputs: Preparing_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing translation jobs...`)
};

const fr_preparing_translation_jobs = /** @type {(inputs: Preparing_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparation des tâches de traduction...`)
};

const de_preparing_translation_jobs = /** @type {(inputs: Preparing_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzungsaufträge werden vorbereitet...`)
};

const it_preparing_translation_jobs = /** @type {(inputs: Preparing_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparazione dei lavori di traduzione...`)
};

const ru_preparing_translation_jobs = /** @type {(inputs: Preparing_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подготовка заказов на перевод...`)
};

const es_preparing_translation_jobs = /** @type {(inputs: Preparing_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando trabajos de traducción...`)
};

const zh_cn2_preparing_translation_jobs = /** @type {(inputs: Preparing_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准备翻译工作……`)
};

const ja_preparing_translation_jobs = /** @type {(inputs: Preparing_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳ジョブを準備しています...`)
};

const hi_preparing_translation_jobs = /** @type {(inputs: Preparing_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद संबंधी कार्य तैयार किए जा रहे हैं...`)
};

const pt_pt2_preparing_translation_jobs = /** @type {(inputs: Preparing_Translation_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando trabalhos de tradução...`)
};

/**
* | output |
* | --- |
* | "Preparing translation jobs..." |
*
* @param {Preparing_Translation_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preparing_translation_jobs = /** @type {((inputs?: Preparing_Translation_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preparing_Translation_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preparing_translation_jobs(inputs)
	if (locale === "de") return de_preparing_translation_jobs(inputs)
	if (locale === "it") return it_preparing_translation_jobs(inputs)
	if (locale === "ru") return ru_preparing_translation_jobs(inputs)
	if (locale === "es") return es_preparing_translation_jobs(inputs)
	if (locale === "zh-CN") return zh_cn2_preparing_translation_jobs(inputs)
	if (locale === "ja") return ja_preparing_translation_jobs(inputs)
	if (locale === "hi") return hi_preparing_translation_jobs(inputs)
	if (locale === "pt-PT") return pt_pt2_preparing_translation_jobs(inputs)
	return en_preparing_translation_jobs(inputs)
});